import React from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../app/hooks';
import { CalendarEvent, Day } from '../helpers/common-types';
import { SvgIcon } from './svg-icon';

export const GridDay = (props: { dayItem: Day, dayIndex: number, withinMonth: boolean, modifiers: string }) => {
    const { dayItem, dayIndex, withinMonth, modifiers } = props;
    const buyTicketCtaDefaultText = useAppSelector(state => state.settings.buyTicketCtaDefaultText);

    const getTitle = (name: string | undefined) => (<h3 className="ace-cal-grid-event-name large" dangerouslySetInnerHTML={{ __html: name || "" }}></h3>);
    const getCta = (buyTicketText: string | undefined) => buyTicketText ? buyTicketText : buyTicketCtaDefaultText;
    const hasEventsClass = dayItem.events.length > 0 ? "has-events" : "";


    return (
        <li className={`ace-cal-grid-day ${modifiers} ${hasEventsClass}`} key={dayIndex} aria-hidden={!withinMonth}>
            <span className="ace-cal-grid-day-date large" tabIndex={-1}>{dayjs(dayItem.date).format("D")}</span>
            {
                dayItem.events.length > 0 &&
                <ul className="ace-cal-grid-day-content">
                    {
                        dayItem.events.map(event => (
                            <li className={`block-${event.theme} ace-cal-grid-event`}>
                                <div className="ace-cal-grid-event-bg"></div>
                                <div className="ace-cal-grid-event-content">
                                    {
                                        event.viewDetailCtaUrl ?
                                            <a className="ace-cal-grid-event-link notranslate" href={event.viewDetailCtaUrl}>{getTitle(event.name)}</a>
                                            : getTitle(event.name)
                                    }
                                    <p className="ace-cal-grid-event-venue"> {event.location}</p>
                                    <p className="ace-cal-grid-event-time">{event.eventTimeString}</p>

                                    {
                                        !event.hideAvailability ?
                                            <p className={`availability-indicator availability-indicator-${event.availabilityType}`}>
                                                {event.availabilityText} </p>
                                            : null
                                    }

                                    <p className="ace-cal-grid-event-cta">
                                        {
                                            event.buyTicketCtaUrl ?
                                                <a href={event.buyTicketCtaUrl} className="btn btn-themed">{getCta(event.buyTicketCtaText)}</a>
                                                : getCta(event.buyTicketCtaText)
                                        }
                                    </p>


                                </div>
                            </li>
                        ))
                    }
                </ul>
            }
        </li>
    )
}